<template>
  <span>
    <b-tabs
      v-if="showFileUpload"
      v-model="tabIndex"
    >
      <b-tab :title="$t('Single User')">
        <validation-observer ref="simpleRules">
          <b-form>

            <!-- Full Name -->
            <b-form-group
              :label="$t('Full Name')"
              label-for="mc-full-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Full Name"
                rules="required"
              >
                <b-form-input
                  v-model="item.fullName"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Full Name')"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Role -->
            <b-form-group
              :label="$t('Role')"
              label-for="mc-role"
            >
              <validation-provider
                #default="{ errors }"
                name="Role"
                rules="required"
              >
                <v-select
                  id="vue-select"
                  v-model="item.role"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionRole"
                  :reduce="role => role.code"
                  label="label"
                  :placeholder="$t('Select role...')"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Email -->
            <b-form-group
              :label="$t('Email')"
              label-for="mc-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  v-model="item.email"
                  :state="errors.length > 0 ? false:null"
                  type="email"
                  :placeholder="$t('Email')"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- User Groups -->
            <b-form-group
              :label="$t('User Groups')"
              label-for="mc-user-groups"
            >
              <v-select
                id="vue-select-user-groups"
                v-model="item.userGroups"
                :options="optionUserGroup"
                :reduce="group => group.id"
                label="groupName"
                :placeholder="$t('Select user groups...')"
                multiple
              />
            </b-form-group>

            <!-- Info -->
            <b-form-group
              :label="$t('Info')"
              label-for="mc-info"
            >
              <b-form-input
                v-model="item.info"
                :placeholder="$t('Info')"
              />
            </b-form-group>

            <!-- MailingCC -->
            <b-form-group
              :label="$t('MailingCC')"
              label-for="mc-mailingcc"
            >
              <b-form-input
                v-model="item.mailingCC"
                :placeholder="$t('MailingCC')"
              />
            </b-form-group>

            <!-- Status -->
            <b-form-group
              :label="$t('Status')"
              label-for="mc-status"
            >
              <b-form-checkbox
                id="checkbox-status"
                v-model="item.status"
                name="checkbox-status"
                switch
              >
                {{ $t('Active') }}
              </b-form-checkbox>
            </b-form-group>

          </b-form>
        </validation-observer>
      </b-tab>
      <b-tab
        :title="$t('Multi User')"
      ><!-- Users HotAlert Configs File Download-->
        <p class="small"><b-link @click="downloadUsers">{{ $t('Download Users') }}</b-link> | <b-link @click="downloadUserFilters">{{ $t('Download User Filters') }}</b-link> | <b-link @click="downloadUserHotAlertConfigs">{{ $t('Download User HotAlert Configs') }}</b-link> | <b-link @click="downloadUserApprovalConfigs">{{ $t('Download User Approval Configs') }}</b-link></p>

        <validation-observer ref="simpleRules2">
          <b-form>

            <!-- Users File -->
            <b-form-group
              :label="$t('1 - Users File')"
              label-for="users_file"
            >
              <b-form-file
                id="users_file"
                v-model="users_file"
                :placeholder="$t('Choose a file or drop it here...')"
                :drop-placeholder="$t('Drop file here...')"
              />
            </b-form-group>

            <!-- Users Filters File -->
            <b-form-group
              :label="$t('2 - Users Filters File')"
              label-for="users_filters_file"
            >
              <b-form-file
                id="users_filters_file"
                v-model="users_filters_file"
                :placeholder="$t('Choose a file or drop it here...')"
                :drop-placeholder="$t('Drop file here...')"
              />
            </b-form-group>

            <!-- Users HotAlert Configs File -->
            <b-form-group
              :label="$t('3 - Users HotAlert Configs File')"
              label-for="users_hotalert_configs_file"
            >
              <b-form-file
                id="users_hotalert_configs_file"
                v-model="users_hotalert_configs_file"
                :placeholder="$t('Choose a file or drop it here...')"
                :drop-placeholder="$t('Drop file here...')"
              />
            </b-form-group>

            <!-- Users Approval Configs File -->
            <b-form-group
              :label="$t('4 - Users Approval Configs File')"
              label-for="users_approval_configs_file"
            >
              <b-form-file
                id="users_approval_configs_file"
                v-model="users_approval_configs_file"
                :placeholder="$t('Choose a file or drop it here...')"
                :drop-placeholder="$t('Drop file here...')"
              />
            </b-form-group>

          </b-form>
        </validation-observer>

      </b-tab>

    </b-tabs>
    <validation-observer
      v-else
      ref="simpleRules"
    >
      <b-form>

        <!-- Full Name -->
        <b-form-group
          :label="$t('Full Name')"
          label-for="mc-full-name"
        >
          <validation-provider
            #default="{ errors }"
            name="Full Name"
            rules="required"
          >
            <b-form-input
              v-model="item.fullName"
              :state="errors.length > 0 ? false:null"
              :placeholder="$t('Full Name')"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Role -->
        <b-form-group
          :label="$t('Role')"
          label-for="mc-role"
        >
          <validation-provider
            #default="{ errors }"
            name="Role"
            rules="required"
          >
            <v-select
              id="vue-select"
              v-model="item.role"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionRole"
              :reduce="role => role.code"
              label="label"
              :placeholder="$t('Select role...')"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Email -->
        <b-form-group
          :label="$t('Email')"
          label-for="mc-email"
        >
          <validation-provider
            #default="{ errors }"
            name="Email"
            rules="required|email"
          >
            <b-form-input
              v-model="item.email"
              :state="errors.length > 0 ? false:null"
              type="email"
              :placeholder="$t('Email')"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- User Groups -->
        <b-form-group
          :label="$t('User Groups')"
          label-for="mc-user-groups"
        >
          <v-select
            id="vue-select-user-groups"
            v-model="item.userGroups"
            :options="optionUserGroup"
            :reduce="group => group.id"
            label="groupName"
            :placeholder="$t('Select user groups...')"
            multiple
          />
        </b-form-group>

        <!-- Info -->
        <b-form-group
          :label="$t('Info')"
          label-for="mc-info"
        >
          <b-form-input
            v-model="item.info"
            :placeholder="$t('Info')"
          />
        </b-form-group>

        <!-- MailingCC -->
        <b-form-group
          :label="$t('MailingCC')"
          label-for="mc-mailingcc"
        >
          <b-form-input
            v-model="item.mailingCC"
            :placeholder="$t('MailingCC')"
          />
        </b-form-group>

        <!-- Status -->
        <b-form-group
          :label="$t('Status')"
          label-for="mc-status"
        >
          <b-form-checkbox
            id="checkbox-status"
            v-model="item.status"
            name="checkbox-status"
            switch
          >
            {{ $t('Active') }}
          </b-form-checkbox>
        </b-form-group>

      </b-form>
    </validation-observer>

  </span>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormCheckbox, BTabs, BTab, BFormFile, BLink,

} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BFormFile,
    BForm,
    BFormCheckbox,
    BTabs,
    BTab,
    vSelect,
    BLink,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    showFileUpload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabIndex: 0,
      defaultItem: {
        fullName: null,
        role: null,
        email: null,
      },
      required,
      optionRole: [
        {
          code: 'user',
          label: 'User',
        },
        {
          code: 'poweruser',
          label: 'Power User',
        },
        {
          code: 'admin',
          label: 'Admin',
        },
        {
          code: 'superadmin',
          label: 'Super Admin',
        },
        {
          code: 'service_account',
          label: 'Service Account',
        },
      ],
      optionUserGroup: [],
      users_file: null,
      users_filters_file: null,
      users_hotalert_configs_file: null,
      users_approval_configs_file: null,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  created() {
    this.getUserGroupOptions()
  },
  methods: {
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    subdomain() {
      const subdomain = window.location.host.split('.')[0]
      return subdomain.split(':').join('')
    },
    downloadUsers() {
      useJwt.axiosIns.get('user/downloadUsers')
        .then(response => {
          if (response.data) {
            this.openFile(response, `users_${this.subdomain()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    downloadUserFilters() {
      useJwt.axiosIns.get('user/downloadUserFilters')
        .then(response => {
          if (response.data) {
            this.openFile(response, `userFilters_${this.subdomain()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    downloadUserHotAlertConfigs() {
      useJwt.axiosIns.get('user/downloadUserHotAlertConfigs')
        .then(response => {
          if (response.data) {
            this.openFile(response, `userHotalertConfigs_${this.subdomain()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    downloadUserApprovalConfigs() {
      useJwt.axiosIns.get('user/downloadUserApprovalConfigs')
        .then(response => {
          if (response.data) {
            this.openFile(response, `userApprovalConfigs_${this.subdomain()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getUserGroupOptions() {
      useJwt.axiosIns.get('usergroup').then(response => {
        this.optionUserGroup = response.data
      })
    },
    validationForm() {
      if (this.tabIndex === 0) {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            if (this.item.id) {
              useJwt.axiosIns.patch('user', this.item)
                .then(response => {
                  if (response.data) {
                    if (response.data === 'Ok') {
                      this.$emit('submit')
                    } else {
                      this.$emit('error', response.data)
                    }
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            } else {
              useJwt.axiosIns.post('user', this.item)
                .then(response => {
                  if (response.data) {
                    if (response.data === 'Ok') {
                      this.$emit('submit')
                    } else {
                      this.$emit('error', response.data)
                    }
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            }
          }
        })
      } else {
        this.$refs.simpleRules2.validate().then(success => {
          if (success && (this.users_file || this.users_filters_file || this.users_hotalert_configs_file || this.users_approval_configs_file)) {
            const formData = new FormData()
            formData.append('UsersFile', this.users_file)
            formData.append('UsersFiltersFile', this.users_filters_file)
            formData.append('UsersHotAlertConfigFile', this.users_hotalert_configs_file)
            formData.append('UsersApprovalConfigFile', this.users_approval_configs_file)

            useJwt.axiosIns.post('user/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              .then(response => {
                if (response.data) {
                  if (response.data === 'Ok') {
                    this.$emit('submit')
                    this.$swal({
                      icon: 'success',
                      title: this.$t('Success'),
                      text: this.$t('Files have been uploaded successfully.'),
                      customClass: {
                        confirmButton: 'btn btn-success',
                      },
                    })
                  } else {
                    this.$emit('error', response.data)
                  }
                  this.users_file = null
                  this.users_filters_file = null
                  this.users_hotalert_configs_file = null
                  this.users_approval_configs_file = null
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            this.$emit('error', 'Select a file!')
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
